// NotFound.js
import React from "react";
import number404Image from "../../Assets/number404Image.jpg"; // เปลี่ยน path ตามที่เก็บไฟล์จริง
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <Container style={{marginBottom: "65px"}}>
      <Row>
        <Col xs={12} md={8} style={{ margin: 'auto'}}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold',textAlign: 'left' }}>{t('Oops! Page Not Found (404)')}</h1>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px', flexWrap: 'wrap' }}>
            <img
              src={number404Image} // เปลี่ยน path ให้ตรงกับตำแหน่งไฟล์จริง
              alt="Error 404"
              style={{ maxWidth: '400px', width: '100%', marginBottom: '20px' }}
            />
            <div style={{ textAlign: 'left', marginLeft: '40px', maxWidth: '400px' }}>
              <p>
                {t("We've looked everywhere, but this page seems to have wandered off. Don't worry, you're not lost for long.")}
              </p>
              <p>
                <a href="/" style={{ color: '#3f51b5', fontWeight: 'bold' }}>{t("Take Me Home")}</a>
              </p>
              <h3 style={{ fontWeight: 'bold' }}>{t("Popular Destinations")}</h3>
              <ul style={{marginTop: "10px"}}>
                <li><a href="/" style={{ color: '#3f51b5', fontWeight: 'bold', marginTop: "15px" }}>{t("Home")}</a></li>
                <li><a href="/about-dcm" style={{ color: '#3f51b5', fontWeight: 'bold', marginTop: "15px" }}>{t("About Us")}</a></li>
                <li><a href="/services" style={{ color: '#3f51b5', fontWeight: 'bold', marginTop: "15px" }}>{t("Services")}</a></li>
                <li><a href="/contact-us" style={{ color: '#3f51b5', fontWeight: 'bold, marginTop: "15px' }}>{t("Contact Us")}</a></li>
              </ul>
              <p>{t("Still can't find what you need? Contact our team.")}</p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFoundPage;
